import axiosInstance from "../../interceptor/axiosInstance";
import {FORGOT_PASSWORD, RESET_PASSWORD, USER_LOGIN, USER_LOGOUT} from "../../routes/routeConstants/apiRoutes";
import { deserialize } from "serializr";
import { User } from "../../models/AuthModel/user.model";
import { store } from "../../store";
import { AUTHENTICATED } from "../../store/definitions/authConstants";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";

export default class UserService {
    static loginUser(
        data: Object,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(USER_LOGIN, data)
            .then(response => {
                const userDetails = deserialize(User, response.data["admin"]);
                const accessDetails = response.data['token'];
                setLocalStorage(userDetails,accessDetails);
                onSuccess(userDetails,accessDetails);
            })
            .catch(error => {
                onError(error);
            })
            .finally(onFinal)
    }

    static logoutUser(
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .delete(USER_LOGOUT)
            .then(() => {
                localStorage.removeItem('token');
                Notification({ message: "Logout", description: "Logged out successfully", type: NotificationTypes.SUCCESS });
                onSuccess();
            })
            .catch(error => {
                Notification({ message: "Logout failed", description: "Unable to logout",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static forgotPassword(
        data: Object,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(FORGOT_PASSWORD, data)
            .then(response => {
                const userDetails = deserialize(User, response.data["user"]);
                Notification({ message: "Success", description: "Mail sent successfully", type: NotificationTypes.SUCCESS });
                onSuccess(userDetails);
            })
            .catch(error => {
                Notification({ message: "Error", description: "Unable to send email",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }

    static resetPassword(
        data: Object,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .put(RESET_PASSWORD, data)
            .then(response => {
                const userDetails = deserialize(User, response.data["user"]);
                Notification({ message: "Success", description: "Mail sent successfully", type: NotificationTypes.SUCCESS });
                onSuccess(userDetails);
            })
            .catch(error => {
                Notification({ message: "Error", description: "Unable to send email",type: NotificationTypes.ERROR });
                onError(error);
            })
            .finally(onFinal)
    }
}

const setLocalStorage = (userDetails:any, accessDetails:any) => {

    localStorage.setItem('token',JSON.stringify(accessDetails));

    store.dispatch({
        type: AUTHENTICATED,
        payload: {
            authenticated: true,
            user: userDetails
        }
    })
}
